<template>
  <div mt-1></div>
  <div class="main-container">
    <div class="title-header" style="margin: 20px 0">
      <h1 class="title">Busqueda de pacientes</h1>
    </div>
    <div class="content-container">
      <v-form
        ref="formRef"
        v-model="formValid"
        @submit.prevent
        @keydown.enter.prevent="canSearch && searchPatient()"
      >
        <v-row>
          <v-col cols="12" lg="3" md="6">
            <v-text-field
              v-model="patientName"
              :rules="requiredInputTextRules"
              ref="patientName"
              :counter="30"
              variant="outlined"
              @input="formatText('patientName')"
              prepend-icon="mdi-account"
              required
              ><template #label>
                Nombre<span class="required">*</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" lg="3" md="6">
            <v-text-field
              v-model="fatherLastName"
              :rules="requiredInputTextRules"
              ref="fatherLastName"
              :counter="30"
              variant="outlined"
              @input="formatText('fatherLastName')"
              prepend-icon="mdi-account-outline"
              required
              ><template #label>
                Primer apellido<span class="required">*</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" lg="3" md="6">
            <v-text-field
              v-model="motherLastName"
              :rules="motherLastNameRules"
              ref="motherLastName"
              :counter="30"
              variant="outlined"
              @input="formatText('motherLastName')"
              prepend-icon="mdi-account-outline"
              label="Segundo apellido"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" lg="3" md="6">
            <v-text-field
              maxlength="10"
              v-model="birthDate"
              @input="formatDate"
              :rules="requiredDateRules"
              hint="Formato DD/MM/AAAA"
              ref="birthDate"
              variant="outlined"
              prepend-icon="mdi-calendar"
              required
              ><template #label>
                Fecha de nacimiento<span class="required">*</span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-space-between align-center">
          <v-col cols="auto" class="d-flex justify-start">
            <button
              type="button"
              style="color: #fff"
              class="boton-principal pr-2"
              @click="recentHistory"
            >
              <v-icon
                icon="mdi mdi-history"
                color="white"
                class="icon"
              ></v-icon>
              Consultas Recientes
            </button>
          </v-col>
          <v-col cols="auto" class="d-flex justify-end">
            <button
              type="button"
              style="color: #fff"
              class="boton-principal pr-2"
              :disabled="!canSearch"
              @click="searchPatient"
            >
              <v-icon
                icon="mdi mdi-magnify"
                color="white"
                class="icon"
              ></v-icon>
              Buscar paciente
            </button>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
  <div class="main-container" v-if="searchItems">
    <div class="title-header" style="margin: 20px 0">
      <h1 class="title" style="text-align: center">Pacientes</h1>
    </div>
    <div class="content-container">
      <div class="d-flex justify-end" style="margin-top: -30px">
        <v-col cols="12" xs="12" sm="auto" class="d-flex justify-center">
          <router-link
            :to="{
              name: 'CrearPaciente',
              query: patientsProps,
            }"
          >
            <button class="boton-principal pr-2">
              <v-icon
                icon="mdi-account-plus"
                color="white"
                class="icon"
              ></v-icon>
              Registrar Paciente
            </button>
          </router-link>
        </v-col>
      </div>
      <EasyDataTable
        table-class-name="customize-table"
        show-index
        alternating
        :headers="headers"
        :items="items"
        :rows-per-page="items.length > 0 ? items.length : 10"
        hide-footer
        class="headers"
      >
        <template #empty-message>
          <span>No se encontraron pacientes que coincidan con la búsqueda.</span>
        </template>
        <template #item-contacto="item">
          <span v-for="(telecom, index) in item.contacto" :key="index">
            <span v-if="telecom.value && telecom.value !== ''">
              <v-icon>
                {{ telecom.type === "Correo" ? "mdi-email" : "mdi-phone" }}
              </v-icon>
              {{ telecom.value }}
            </span>
            <br />
          </span>
        </template>

        <template #item-operation="item">
          <v-btn
            class="ma-2 pa-2 boton-expediente"
            @click="seendtoExpediente(item)"
            variant="plain"
          >
            Ver Expediente
          </v-btn>
        </template>
      </EasyDataTable>
    </div>
  </div>
  <v-dialog v-model="dialog_alert" max-width="400">
    <v-row justify="center">
      <v-card>
        <i
          class="mdi mdi-close-circle boton-cerrar-x"
          style="
            position: absolute;
            top: 10px;
            right: 10px;
            float: right;
            font-size: 25px;
            cursor: pointer;
            color: white;
          "
          @click="dialog_alert = false"
        ></i>
        <v-card-title> Alerta </v-card-title>
        <v-card-text style="margin-top: 20px">
          {{ dialog_alert_message }}
        </v-card-text>
      </v-card>
    </v-row>
  </v-dialog>
</template>

<script>
import EasyDataTable from "vue3-easy-data-table";
import { getPatientByNameAndBirthdate } from "@/api/pacientes";
import { formatDate, validateDate } from "@/utils/converte_date";
import { formatText } from "@/utils/converte_text";

export default {
  components: {
    EasyDataTable,
  },
  mounted() {
    this.restoreSearchWithExpiration();
    this.checkNotification();
  },
  beforeUnmount() {
    if (this.expirationTimer) {
      clearTimeout(this.expirationTimer);
      this.expirationTimer = null;
    }
  },
  watch: {
    "$route.query.notificacion"(newVal) {
      this.checkNotification(newVal);
    },
  },
  methods: {
    restoreSearchWithExpiration() {
      const savedTimestamp = localStorage.getItem("searchTimestamp");
      const savedParams = localStorage.getItem("searchParams");

      if (!savedParams || !savedTimestamp) {
        this.clearSearchData();
        return;
      }

      const elapsed = Date.now() - parseInt(savedTimestamp, 10);
      const maxAge = 10 * 60 * 1000; // 10 minutos

      if (isNaN(elapsed) || elapsed < 0 || elapsed >= maxAge) {
        this.clearSearchData();
        return;
      }

      // Vigente (< 10 minutos)
      try {
        const parsed = JSON.parse(savedParams);
        if (parsed.patientName) {
          this.patientName = parsed.patientName || "";
          this.fatherLastName = parsed.fatherLastName || "";
          this.motherLastName = parsed.motherLastName || "";
          this.birthDate = parsed.birthDate || "";

          const savedResultsStr = localStorage.getItem("searchResults");
          let savedResults = null;
          try {
            savedResults = savedResultsStr ? JSON.parse(savedResultsStr) : null;
          } catch (e) {
            savedResults = null;
          }

          if (Array.isArray(savedResults)) {
            this.items = savedResults;
            this.searchItems = true;
          }

          const remainingTime = maxAge - elapsed;
          this.scheduleCacheExpiration(remainingTime);
        } else {
          this.clearSearchData();
        }
      } catch (e) {
        this.clearSearchData();
      }
    },
    scheduleCacheExpiration(timeMs) {
      if (this.expirationTimer) {
        clearTimeout(this.expirationTimer);
      }
      this.expirationTimer = setTimeout(() => {
        this.clearSearchData();
      }, timeMs);
    },
    async searchPatient() {
      if (this.$refs.formRef) {
        const { valid } = await this.$refs.formRef.validate();
        if (!valid) {
          return;
        }
      }

      if (
        !this.patientName?.trim() ||
        !this.fatherLastName?.trim() ||
        !this.birthDate?.trim()
      ) {
        return;
      }

      this.isManualSearch = true;
      this.items = [];
      const formData = {
        name: [this.patientName.trim()],
        lastName: [this.fatherLastName.trim(), this.motherLastName?.trim() || ""],
        birthDate: this.birthDate.trim(),
      };
      const searchParams = {
        patientName: this.patientName.trim(),
        fatherLastName: this.fatherLastName.trim(),
        motherLastName: this.motherLastName?.trim() || "",
        birthDate: this.birthDate.trim(),
      };
      this.searchItems = false;

      // Guardar parámetros de búsqueda y timestamp de expiración (10 min)
      localStorage.setItem("searchParams", JSON.stringify(searchParams));
      localStorage.setItem("searchTimestamp", Date.now().toString());

      getPatientByNameAndBirthdate(formData)
        .then((items) => {
          if (items && items.length > 0) {
            // Patients found - show results
            const newItems = items.map((item) => {
              return {
                id: item.id,
                nombre: item.nombre,
                primerApellido: item.primerApellido,
                segundoApellido: item.segundoApellido,
                contacto: item.telecom,
                birthdate: item.birthdate,
              };
            });
            this.items = newItems;
            this.searchItems = true;
            localStorage.setItem("searchResults", JSON.stringify(this.items));
            this.scheduleCacheExpiration(10 * 60 * 1000);
          } else {
            // No patients found - display empty results table with register option
            this.items = [];
            this.searchItems = true;
            localStorage.setItem("searchResults", JSON.stringify([]));
            this.scheduleCacheExpiration(10 * 60 * 1000);
          }
        })
        .catch((error) => {
          console.error("Error message:", error?.message);
          if (error?.response?.data) {
            console.error("Response data:", error.response.data);
          }

          // In case patient is not found (404), show empty table with option to register
          this.items = [];
          this.searchItems = true;
          localStorage.setItem("searchResults", JSON.stringify([]));
          this.scheduleCacheExpiration(10 * 60 * 1000);
        })
        .finally(() => {
          this.isManualSearch = false; // Reset the flag
        });
    },
    assignPatientId(item) {
      localStorage.setItem("patientId", item);
    },
    seendtoExpediente(item) {
      const numericId = item.id.replace(/[^0-9]+/g, "");
      this.assignPatientId(numericId);
      this.$router.push({
        params: { id: numericId },
        name: "Expediente",
      });
    },
    formatDate(event) {
      this.birthDate = formatDate(event);
    },
    formatText(fieldName) {
      this[fieldName] = formatText(this[fieldName]);
    },
    checkNotification(value) {
      if (!this.enableNotifications) return;
      const notificacion = value ?? this.$route.query.notificacion;

      if (notificacion === "accion-completada") {
        // this.showNotification(
        //     'Recuerda que se acerque a farmacia porque le pueden dar opciones',
        // );

        // Limpiar query después de mostrar
        const query = { ...this.$route.query };
        delete query.notificacion;
        this.$router.replace({ query });
      }
    },
    showNotification(message) {
      this.dialog_alert_message = message;
      this.dialog_alert = true;
      setTimeout(() => {
        this.dialog_alert = false;
      }, 10000);
    },
    clearSearchData() {
      // Clear localStorage
      localStorage.removeItem("searchParams");
      localStorage.removeItem("searchResults");
      localStorage.removeItem("searchTimestamp");

      if (this.expirationTimer) {
        clearTimeout(this.expirationTimer);
        this.expirationTimer = null;
      }

      // Clear component state
      this.patientName = "";
      this.fatherLastName = "";
      this.motherLastName = "";
      this.birthDate = "";
      this.items = [];
      this.searchItems = false;
      this.isManualSearch = false;

      if (this.$refs.formRef) {
        this.$refs.formRef.resetValidation(); // Use resetValidation instead of reset
      }
    },
    recentHistory() {
      this.$router.push({
        name: "ConsultasRecientes",
      });
    },
  },
  data() {
    const reglasComunes = {
      requerido: (v) =>
        (!!v && String(v).trim().length > 0) || "Este campo es obligatorio.",
      longitudMaxima: (max) => (v) =>
        (v && v.length <= max) ||
        `El campo no puede tener más de ${max} caracteres.`,
      longitudMinima: (min) => (v) =>
        (v && v.length >= min) ||
        `El campo debe tener al menos ${min} caracteres.`,
      soloLetras: (v) =>
        /^[A-Za-zÀ-ÖØ-öø-ÿ\s’'-]+$/u.test(v) ||
        "El campo solo puede contener letras, espacios, guiones y apóstrofes.",
      noCaracteresInicioFin: (v) =>
        !/^[\s’'-]|[\s’'-]$/.test(v) ||
        "El campo no puede comenzar o terminar con espacios, guiones o apóstrofes.",
      opcional: (regla) => (v) => !v || regla(v), // Función para campos opcionales
    };
    return {
      expirationTimer: null,
      isManualSearch: false,
      patientName: "",
      fatherLastName: "",
      motherLastName: "",
      birthDate: "",
      formValid: false,
      items: [],
      searchItems: false,
      enableNotifications: false,
      headers: [
        { text: "ID", value: "id", sortable: true },
        { text: "Nombre(s)", value: "nombre", sortable: true },
        {
          text: "Primer Apellido",
          value: "primerApellido",
          sortable: true,
        },
        {
          text: "Segundo Apellido",
          value: "segundoApellido",
          sortable: true,
        },
        { text: "Fecha de nacimiento", value: "birthdate" },
        { text: "Contacto", value: "contacto" },
        { text: "Acciones", value: "operation" },
      ],
      rowsPerPage: 10,
      requiredInputTextRules: [
        reglasComunes.requerido,
        reglasComunes.longitudMaxima(30),
        reglasComunes.longitudMinima(2),
        reglasComunes.soloLetras,
        reglasComunes.noCaracteresInicioFin,
      ],
      motherLastNameRules: [
        reglasComunes.opcional(reglasComunes.longitudMaxima(30)),
        reglasComunes.opcional(reglasComunes.longitudMinima(2)),
        reglasComunes.opcional(reglasComunes.soloLetras),
        reglasComunes.opcional(reglasComunes.noCaracteresInicioFin),
      ],
      inputTextRules: [
        reglasComunes.opcional(reglasComunes.longitudMaxima(30)),
        reglasComunes.opcional(reglasComunes.longitudMinima(2)),
        reglasComunes.opcional(reglasComunes.soloLetras),
        reglasComunes.opcional(reglasComunes.noCaracteresInicioFin),
      ],
      requiredDateRules: [
        reglasComunes.requerido,
        (v) =>
          /^\d{2}\/\d{2}\/\d{4}$/.test(v) ||
          "El formato debe ser DD/MM/AAAA",
        (v) => validateDate(v) || "La fecha no es válida",
      ],
      dateRules: [
        (v) =>
          !v ||
          /^\d{2}\/\d{2}\/\d{4}$/.test(v) ||
          "El formato debe ser DD/MM/AAAA",
        (v) => !v || validateDate(v) || "La fecha no es válida",
      ],
      dialog_alert: false,
      dialog_alert_message: "",
    };
  },
  computed: {
    patientsProps() {
      return {
        name: this.patientName,
        patientFatherLastName: this.fatherLastName,
        patientMotherLastName: this.motherLastName,
        patientBirthDate: this.birthDate,
      };
    },
    canSearch() {
      return (
        !!this.patientName?.trim() &&
        !!this.fatherLastName?.trim() &&
        !!this.birthDate?.trim() &&
        this.formValid
      );
    },
  },
};
</script>

<style>
.headers div table thead tr th span {
  color: var(--color-secundario);
  font-size: 15px;
}
.boton-expediente {
  color: #40b4e5;
  text-decoration: underline;
}
.altura-boton {
  height: 40px;
  position: relative;
  top: 29px;
}

.cabezera {
  color: white;
  text-align: center;
}

.font {
  color: white;
}

.customize-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid black;
  border-radius: 10px;
}

.icon {
  align-self: Center;
  color: black;
  margin-right: 2px;
  margin-left: 1px;
}

.table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid black;
  border-radius: 10px;
}
.required {
  color: red;
}
</style>
